module.exports = __webpack_public_path__ + "img/Frame 5.b5492d5c.png";